import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import App from '../../App'
import Login from '../../pages/Login'
import Temp from '../../pages/Temp'
import NotFound from '../../pages/NotFound'
import { addLocale, locale } from 'primereact/api'
import {useTranslation} from "react-i18next";
import { tokens } from 'locales/tokens';


const AppWrapper = () => {
    let location = useLocation()
    const {t, i18n} = useTranslation();
    const path = location.pathname

    addLocale(i18n.language, {
        firstDayOfWeek: 1,
        dayNames: [
            t(tokens.common.monday),
            t(tokens.common.tuesday),
            t(tokens.common.wednesday),
            t(tokens.common.thursday),
            t(tokens.common.friday),
            t(tokens.common.saturday),
            t(tokens.common.sunday)
        ],
        dayNamesShort: [
            t(tokens.common.sunday_short),
            t(tokens.common.monday_short),
            t(tokens.common.tuesday_short),
            t(tokens.common.wednesday_short),
            t(tokens.common.thursday_short),
            t(tokens.common.friday_short),
            t(tokens.common.saturday_short)
        ],
        dayNamesMin:  [
            t(tokens.common.sunday_short),
            t(tokens.common.monday_short),
            t(tokens.common.tuesday_short),
            t(tokens.common.wednesday_short),
            t(tokens.common.thursday_short),
            t(tokens.common.friday_short),
            t(tokens.common.saturday_short)
        ],
        monthNames: [
            t(tokens.common.january),
            t(tokens.common.february),
            t(tokens.common.march),
            t(tokens.common.april),
            t(tokens.common.may),
            t(tokens.common.june),
            t(tokens.common.july),
            t(tokens.common.august),
            t(tokens.common.september),
            t(tokens.common.october),
            t(tokens.common.november),
            t(tokens.common.december)
        ],
        monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        today: t(tokens.common.today),
        clear: t(tokens.common.reset),
    })

    locale(i18n.language)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])

    switch (path) {
        case '/login':
            return <Login />
        // case '/rdms-developer':
        //     return <Login />
        case '/notfound':
            return <NotFound />
        default:
            return <App />
    }
}

export default AppWrapper
